import { get } from '../../helpers/utils/http-client';
import { APPS_ENDPOINT } from '../../consts/api-endpoints';

export const SESSION_PAGE_SIZE = 25;

const EMPTY_PAGE = { data: [], pagination: {} };

/**
 * List an app's sessions, most recently active first.
 *
 * Mirrors the platform's session service: the backend only honours
 * `requestPage` when `pageSize` travels with it, and the cursor is a DynamoDB
 * LastEvaluatedKey, so paging is forward-only with no total count.
 *
 * This route is registered behind the customer API's Cognito authorizer, so an
 * unauthenticated guest gets a 401 here. That is not fatal: the caller merges
 * this with the browser-local session index, so the history rail still lists
 * the conversations this visitor actually had.
 */
export async function getSessions(appId, requestPage, pageSize = SESSION_PAGE_SIZE, accessKey) {
  try {
    const params = { pageSize };
    if (requestPage) {
      params.requestPage = requestPage;
    }

    const { response, status } = await get(
      `${APPS_ENDPOINT}/${appId}/sessions`,
      params,
      accessKey ? { Authorization: accessKey } : {}
    );

    if (status !== 200) {
      return { ...EMPTY_PAGE, unauthorized: status === 401 || status === 403 };
    }
    return response;
  } catch (err) {
    console.debug('getSessions failed cause', err.message, err.code);
    return EMPTY_PAGE;
  }
}

/** Transcript of one session, oldest message first. */
export async function getMessages(appId, sessionId, accessKey) {
  try {
    const { response, status } = await get(
      `${APPS_ENDPOINT}/${appId}/sessions/${sessionId}/messages`,
      {},
      accessKey ? { Authorization: accessKey } : {}
    );
    if (status !== 200) {
      return { data: [], unauthorized: status === 401 || status === 403 };
    }
    return response;
  } catch (err) {
    console.debug('getMessages failed cause', err.message, err.code);
    return { data: [] };
  }
}
